var cartCheckTimeout;
var pendingCartUpdate = false;
var cartPageCartChange = false; // Added for cart page fix
var lastCall = Date.now();
const originalAjax = $.ajax;

console.log('Ajax watch loaded', typeof originalAjax === 'function');
console.log(false);

// Override $.ajax
$.ajax = function(options) {
    let prevTime = lastCall;
    lastCall = Date.now();
    if (options._ignoreCustomCheckFlag === true) {
        return originalAjax.apply(this, arguments);
    }

    // Check if the request URL contains '/cart.js'
    if (options.url) {
        // Check if the request URL contains '/cart.js'
        if (options.url.includes('/cart.js')) {
            if (pendingCartUpdate === false) {
                return originalAjax.apply(this, arguments);
            }

            // Clear the timeout since /cart.js is already being called
            clearTimeout(cartCheckTimeout);
            cartCheckTimeout = null;

            // Wrap the success callback to intercept the response
            const originalSuccess = options.success;

            options.success = function(data) {
                pendingCartUpdate = false;
                
                // Intercept the response and perform customer processes here
                handleCartCheckForCacaoProductsSubtotal(data);

                // Call the original success function, if defined
                if (typeof originalSuccess === 'function') {
                    originalSuccess(data);
                }
            };
        } else
        // Check if the request URL contains '/cart/'
        if (options.url.includes('/cart/')) {
            // Wrap the success callback to intercept the response
            const originalSuccess = options.success;
            
            options.success = function(data) {
                pendingCartUpdate = true;
                cartPageCartChange = true; // Added for cart page fix
                // Intercept the response and perform customer processes here
                initiateCartCheckTimeout();

                // Call the original success function, if defined
                if (typeof originalSuccess === 'function') {
                    originalSuccess(data);
                }
            };
        }
    }
    
    // Call the original $.ajax with modified options
    return originalAjax.apply(this, arguments);
};

function initiateCartCheckTimeout() {
    if (cartCheckTimeout !== null) {
        clearTimeout(cartCheckTimeout);
        cartCheckTimeout = null;
    }

    // Set up a delayed call to /cart.js if it hasn't been called within 1 second
    cartCheckTimeout = setTimeout(() => {
        // Call /cart.js to ensure the latest cart state is retrieved
        pendingCartUpdate = false;

        $.ajax({
            url: '/cart.js',
            dataType: 'json',
            success: (...args) => {
              checkIfBelowThreshold(...args);
              handleCartCheckForCacaoProductsSubtotal(...args);
            },
        });
    }, 1000); // 1 second before required call
}

const shopifyBundleVariantId = "41204847607851";
const magicBundleVariantPromoActive = false;
// Define a custom handler function for the cart change response
function handleCartCheckForCacaoProductsSubtotal(data) {
    if (magicBundleVariantPromoActive !== true) {
      return;
    }
  
    // Check if response contains cart items
    if (!data || !data.items || data.items.length === 0) {
        return;
    }

    const cartItems = data.items;

    let cacaoProductSubtotal = 0;
    let bundleIsAlreadyAddedToCart = false;
    cartItems.forEach(item => {
        const { product_type: type, variant_id: variantId } = item;

        if (type === 'Cacao') {
            cacaoProductSubtotal += item.final_line_price;
        }

        if (shopifyBundleVariantId == variantId) {
            bundleIsAlreadyAddedToCart = true;
        }
    });

    let productShouldBeAddedToCart = false;
    // if (shopifyTemplate !== 'cart' || cartPageCartChange === false) {
        // If price is over 300.00, show modal 2 for the 100% discount off magic bundle
        if (cacaoProductSubtotal >= 30000 && sessionStorage.getItem("magicBundle300Reached") === 'false') {
            productShouldBeAddedToCart = true;
    
            // Show magic 300 discount modal
            const popover = document.querySelector('[data-use-for-magic300]');
            if (popover) { 
                smbOpenPopover(popover);
            }

            sessionStorage.setItem("magicBundle300Reached", "true");
        }
        // // If price is over 150.00, show modal 1 for the 50% discount off magic bundle
        // else if (cacaoProductSubtotal >= 15000 && sessionStorage.getItem("magicBundle150Reached") === 'false') {
        //     productShouldBeAddedToCart = true;
    
        //     // Show magic 150 discount modal
        //     const popover = document.querySelector('[data-use-for-magic150]');
        //     if (popover) { 
        //         smbOpenPopover(popover);
        //     }

        //     sessionStorage.setItem("magicBundle150Reached", "true");
        // }
    // }

    if (productShouldBeAddedToCart && !bundleIsAlreadyAddedToCart) {
        $.ajax({
            url: '/cart/add.js',
            dataType: 'json',
            cache: false,
            type: 'post',
            data: {
                items: [ { id: shopifyBundleVariantId, quantity: 1 } ]
            },
            success() {
                sessionStorage.setItem("magicBundleAdded", "true");

                // Update mini cart notification
                $.ajax({
                    url: '/cart.js',
                    dataType: 'json',
                    cache: false,
                    _ignoreCustomCheckFlag: true,
                    success(cart) {
                        // Added fix for cart page not reloading
                        if (shopifyTemplate === 'cart') {
                            // window.location.reload();
                            // window.refreshCart();

                            // Do nothing
                        } else {
                            try {
                                // Refresh cart and ignore verify
                                window.refreshCart(cart, true);
                            } catch (err) {
                                console.error(err);
                            }

                            if ($('body').hasClass('fancybox-active')) {
                                $.fancybox.close();
                            }

                            if ($('#header').is(':visible')) {
                                $('#header .cart-container').addClass('active_link');
                            } else if ($('.sticky_nav--stick').length) {
                                $('.sticky_nav .cart-container').addClass('active_link');
                            } else {
                                $('.top-bar .cart-container').addClass('active_link');
                            }

                            // block scrolling on mobile
                            if (window.Shopify.media_queries.medium.matches) {
                                const $cartContainer = $(this).parent();
                                if ($cartContainer.hasClass('active_link')) {
                                    $('body').addClass('blocked-scroll');
                                } else {
                                    $('body').addClass('blocked-scroll');
                                }
                            }
                        }
                    },
                });
            },
            error(XMLHttpRequest) {
                let response = eval(`(${XMLHttpRequest.responseText})`);
                console.error(response.description);
            },
        });
    } else if (shopifyTemplate === 'cart' && cartPageCartChange === true) {
        // Added fix for cart page not reloading
        // window.location.reload();
        // window.refreshCart();
        // Do nothing
    }
}

function checkIfBelowThreshold(data) {
  if (magicBundleVariantPromoActive === true) {
    // If total price is lower than Magic bundle 150 then remove reached flag
    // if (data.total_price < 15000) {
    //   sessionStorage.setItem("magicBundle150Reached", "false");
    // }
    
    // If total price is lower than Magic bundle 300 then remove reached flag
    if (data.total_price < 30000) {
      sessionStorage.setItem("magicBundle300Reached", "false");
    }
  }
}

// Run once on page load
checkIfBelowThreshold(ajaxWatchCart);
handleCartCheckForCacaoProductsSubtotal(ajaxWatchCart); // Global ajaxWatchCart data
